<div class="representante">
    <div class="container-header">
        <nav class="container-header-block container-header-breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">Representantes</li>
            </ol>
        </nav>

        <div class="container-header-block container-header-btns">
            <!-- Opções -->
            <div class="btn-group" *ngIf="options?.hasAnyOption()">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-none d-sm-inline-block">Opções</span>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" *ngIf="options?.canImportar" (click)="openImportModal()">
                        <i class="fas fa-upload" aria-hidden="true"></i> Importar
                    </a>

                    <!-- Import ERP V1 -->
                    <a class="dropdown-item" *ngIf="options?.canImportErp_v1" (click)="openIntegracaoErpImportModal_v1()">
                        <i class="fas fa-download"></i> Importar do ERP
                    </a> 
                </div>
            </div>          
        </div>
        
        <div class="container-header-block container-header-visualizacao" *ngIf="visualizacao">
            <div class="btn-toolbar">
                <div class="btn-group ml-2 mb-2 mb-sm-0">
                    <ng-template ngFor let-visualizacaoModo [ngForOf]="visualizacaoModos">
                        <label class="btn btn-light m-0" [class.active]="visualizacaoModo.id === visualizacao.modo" for="visualizacaoModo_{{visualizacaoModo.id}}" [title]="visualizacaoModo.nome">
                            <input type="radio" class="custom-control-input" name="visualizacaoModo" id="visualizacaoModo_{{visualizacaoModo.id}}"
                                [value]="visualizacaoModo.id" [ngModel]="visualizacao.modo" (ngModelChange)="onChangeVisualizacaoModo($event ? $event : null)"> <i [class]="visualizacaoModo.iconClass"></i>                                       
                        </label>                 
                    </ng-template>
                </div>
            </div>
        </div>        
    </div>  

    <div class="container-filter">
        <sgt-representante-filter
            #representanteFilter
            [filter]="filter"
            (filterInitialized)="onFilterInitialized()"
            (filterChange)="onFilterChange()"
            (filterCleaned)="onFilterCleaned()">
        </sgt-representante-filter>
    </div>    

    <div class="container-content" #containerContent>   
        <!-- List -->
        <ng-template [ngIf]="isVisualizacaoModoList()">
            <sgt-representante-list
                #list
                [filter]="filter"
                (orderByChanged)="orderBy = $event"
                (orderByDirChanged)="orderByDir = $event">
            </sgt-representante-list>
        </ng-template>       

        <!-- Dashboad -->
        <ng-template [ngIf]="isVisualizacaoModoDashboard()">
            <sgt-representante-dashboard
                #dashboard
                [filter]="filter">
            </sgt-representante-dashboard>
        </ng-template>               
    </div>    
</div>

<!-- Modal para alterar a senha -->
<sgt-representante-import-modal
    idModal="representanteImportModal"
    (afterImport)="onAfterImport()"
    #representanteImportModal>
</sgt-representante-import-modal>


<!-- Modal para importar representantes do ERP V1 -->
<sgt-integration-representante-modal
    #integrationModal
    (afterExecuteIntegration)="afterImportErp_v1()">
</sgt-integration-representante-modal>